import { connect } from 'react-redux'
import { UpdatePackForm as Form } from './UpdatePackForm'
import { AppStateType } from '../../reducers'
import { selectLanguages } from '../../selectors/languages'
import { selectIsDeletedFilePresentInEditions } from '../../selectors/pack'

const mapStateToProps = (state: AppStateType) => ({
  serverConfig: state.serverConfig,
  languages: selectLanguages(state),
  isDeletedFilePresentInEditions: selectIsDeletedFilePresentInEditions(state),
})

export const UpdatePackForm = connect(mapStateToProps)(Form)
